<section class="">
  <!-- Form -->
  <form [formGroup]="adminForm" class="space-y-5">
    <!-- First Name & Last Name -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <app-custom-input [label]="'First Name'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'Enter first name'" formControlName="firstName"></app-custom-input>
        @if (adminForm.get('firstName')?.invalid && (adminForm.get('firstName')?.touched ||
        adminForm.get('firstName')?.dirty)) {
        <div class="text-error text-xs mt-2">First name is required.</div>
        }
      </div>
      <div>
        <app-custom-input [label]="'Last Name'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'Enter last name'" formControlName="lastName"></app-custom-input>
        @if (adminForm.get('lastName')?.invalid && (adminForm.get('lastName')?.touched ||
        adminForm.get('lastName')?.dirty)) {
        <div class="text-error text-xs mt-2">Last name is required.</div>
        }
      </div>
    </div>

    <!-- Other Name -->
    <div>
      <app-custom-input [label]="'Other Name'" [showAsteric]="false" [showLabel]="true"
        [placeholder]="'Enter other name (optional)'"
        formControlName="otherName"></app-custom-input>
    </div>

    <!-- Email & Mobile Number -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <app-custom-input [label]="'Email'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'Enter email address'" formControlName="email" type="email"></app-custom-input>
        @if (adminForm.get('email')?.invalid && (adminForm.get('email')?.touched || adminForm.get('email')?.dirty)) {
        <div class="text-error text-xs mt-2">
          @if (adminForm.get('email')?.errors?.['required']) {
          Email is required.
          } @else if (adminForm.get('email')?.errors?.['email']) {
          Please enter a valid email address.
          }
        </div>
        }
      </div>
      <div>
        <app-custom-input [label]="'Mobile Number'" [showAsteric]="true" [showLabel]="true"
          [placeholder]="'Enter mobile number'" formControlName="mobileNumber"></app-custom-input>
        @if (adminForm.get('mobileNumber')?.invalid && (adminForm.get('mobileNumber')?.touched ||
        adminForm.get('mobileNumber')?.dirty)) {
        <div class="text-error text-xs mt-2">Mobile number is required.</div>
        }
      </div>
    </div>

    <!-- Role -->
    <div>
      <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">
        Role <span class="text-error">*</span>
      </label>
      <app-custom-select-input [options]="roleOptions" [placeholder]="'Select a role'"
        formControlName="roleId"></app-custom-select-input>
      @if (adminForm.get('roleId')?.invalid && (adminForm.get('roleId')?.touched || adminForm.get('roleId')?.dirty)) {
      <div class="text-error text-xs mt-2">Role is required.</div>
      }
    </div>

    <!-- Submit Button -->
    <div class="pt-4">
      <app-primary-button [text]="admin() && isEdit() ? 'Update' : 'Confirm'" [isLoading]="isLoading"
        (onClickEvent)="onSubmit()"></app-primary-button>
    </div>
  </form>
</section>